<template>
  <div v-if="cert_data != null">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <template>
      <div v-if="show == true" id="document1" style="width:1000px;height:780px">
        <!-- {{org_basic_data}} -->
        <div class="printdiv v-card" style="
            border: 3px solid;
            border-color: black;
            position: absolute;
            padding: 10px;
            margin-left: 6%;
            margin-right: 6%;
            margin-top: 5%;
          ">
          <v-row justify="center">
            <v-col cols="12" sm="2" md="2" align="right">
              <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" width="75%" alt="logo" />
            </v-col>
            <v-col cols="12" sm="8" md="8" class="line-height">
              <center>
                <br />
                <strong>
                  <span v-if="org_basic_data.trust_name">{{
                    org_basic_data.trust_name
                    }}</span></strong><br />
                <strong>
                  <h1 class="schl-name" v-if="org_basic_data.school_name">
                    {{ org_basic_data.school_name }}
                  </h1>
                </strong>
                <b v-if="this.org_id == 'sbpps'">CBSE Affiliation Number: 1130 534 <br>
                    NABET Accreditation Number: 2428 071 ▪ QS I-GAUGE Diamond+ Rated <br>
                    British Council Recognition of International Dimension in Schools 2026-2029
                  </b><br>
                <span v-if="org_basic_data.address">{{
                  org_basic_data.address
                  }}</span><br />
                <!-- <span class="pr-8" v-if="org_basic_data.phone"><b>Phone : </b> {{ org_basic_data.phone }}</span>
                <span class="space pr-8" v-if="org_basic_data.email"><b>Email : </b> {{ org_basic_data.email }}</span>
                <span v-if="org_basic_data.website"><b>Website : </b> {{ org_basic_data.website }}</span> -->
                <div class="contact-details">
                  <span v-if="org_basic_data.phone">
                    <b>Phone : </b>{{ org_basic_data.phone }}
                  </span>

                  <span v-if="org_basic_data.email">
                    <b>Email : </b>{{ org_basic_data.email }}
                  </span>

                  <span v-if="org_basic_data.website">
                    <b>Website : </b>{{ org_basic_data.website }}
                  </span>
                </div>
              </center>
            </v-col>
            <v-col cols="12" sm="2" md="2" align="left">
              <br />
              <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
            </v-col>
          </v-row>
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong v-if="org_id != 'sbpps'">Affiliation No: 1130534</strong><br />
              <strong v-if="cert_data != null">Sr. No. {{ cert_data.cert_no }}</strong>
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3"><span style="margin-right: 15%">Date: {{ cert_data.cert_date
            }}</span></v-col>
          </v-row>
          <center>
            <strong>
              <span style="font-size: 1.3em; text-transform: uppercase">To whomsoever it may concern</span>
            </strong>
          </center>
          <br />
          <v-row class="ml-2 line-height">
            <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
              <i>
                This is to verify that Miss / Master
                <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.stud_name
                }}</span></strong>
              </i>
              <br />
              <br />
              is / was the student of Grade
              <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.std
              }}</span></strong>
              Div.
              <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.div
              }}</span></strong>
              for the academic year
              <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.ay
              }}</span></strong><br />
              <br />
              His / Her Date of birth according to our record is
              <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.dob
              }}</span></strong><br />
              <br />
              His / Her address is
              <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.address
              }}</span></strong>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="student-photo-col">
              <img
                v-if="cert_data.photo != null"
                :src="awspath + cert_data.photo"
                class="student-photo"
                alt="student photo"
              />
            </v-col>
          </v-row>
          <v-row class="ml-2 line-height">
            <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
              He / She bears a good moral character. This certificate is issued
              for Ration card / Bank account / Aadhaar Card / Caste Certificate /
              VISA / Passport.
            </v-col>
          </v-row>
          <br />
          <br />
          <br />
          <br />
          <div class="bottomright">
            <span style="font-size: 1.3em"><strong>PRINCIPAL</strong></span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      search: "",
      awspath: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      cert_data: null,
      show: true,
      org_id: null,
      org_basic_data: [],
      progress: 0,
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
    print() {
      var content = document.getElementById("document1").innerHTML;
      var mywindow = document.body.innerHTML;
      document.body.innerHTML = content;
      window.print();
      document.body.innerHTML = mywindow;
      location.reload();
      return true;
    },
    close() {
      this.$router.push({ name: "certificate-bonafied", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.cert_data = JSON.parse(this.$route.query.cert_data || '{}');
      this.org_basic_data = JSON.parse(this.$route.query.org_basic_data || '{}');
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-tenant");
    this.onload();
  },
};
</script>
<style scoped>
.bottomright {
  position: absolute;
  bottom: 8px;
  right: 16px;
  font-size: 18px;
  margin-top: 20px;
}
.student-photo-col {
  font-size: 1.3em;
  position: relative;
  top: -65px; /* move photo upward */
}

.student-photo {
  width: 75%;
}
@media print {
  .printdiv {
    height: 1500px;
  }

  .bottomright {
    font-size: 35px !important;
    margin-top: 60px !important;
  }

  .schl-name {
    margin: 10px 0px;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .student-photo-col {
    top: -75px !important;
  }

  .student-photo {
    width: 100% !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .v-card {
    font-size: 2em !important;
  }

  @page {
    size: A4 landscape;
    size: 25in 18.5in;
  }

  .line-height {
    line-height: 180% !important;
  }
}
</style>
